import { useState, useEffect } from "react";

const MOBILE_BREAKPOINT = 768;

/**
 * Mirrors the prime-main DeviceSwitch pattern. Returns false on the
 * server / first client render to avoid hydration mismatch, then flips
 * to the real value after mount. Listens to resize so toggling devtools
 * device preview also flips the layout.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const check = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  return isMobile;
}
